import { render } from "./option-time.vue?vue&type=template&id=16a23b8d&scoped=true"
import script from "./option-time.vue?vue&type=script&lang=js"
export * from "./option-time.vue?vue&type=script&lang=js"

import "./option-time.vue?vue&type=style&index=0&id=16a23b8d&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a23b8d"]])

export default __exports__